/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {MutationTree} from 'vuex';
import {Vue} from 'vue-property-decorator';
import {SearchIssueInterface, SearchStateInterface} from '@/store/modules/search/types';
import {IssueInterface} from '@/store/modules/issues/types';

export const mutations: MutationTree<SearchStateInterface> = {
    //
    // /**
    //  * Update the stage searchTerm.
    //  *
    //  * @param {SearchStateInterface} state
    //  * @param {string} newTerm
    //  */
    // searchTerm(state: SearchStateInterface, newTerm: string): void {
    //     Vue.set(state, 'searchTerm', newTerm);
    // },
    //
    // /**
    //  * Update the stage searchResults.
    //  *
    //  * @param {SearchStateInterface} state
    //  * @param {IssueInterface[]} newResults
    //  */
    // searchResults(state: SearchStateInterface, newResults: IssueInterface[]): void {
    //     Vue.set(state, 'searchResults', newResults);
    //     Vue.set(state, 'error', false);
    // },

    /**
     * Update the stage search terms and results.
     *
     * @param {SearchStateInterface} state
     * @param {SearchIssueInterface} newSearch
     */
    searchResults(state: SearchStateInterface, newSearch: SearchIssueInterface): void {
        Vue.set(state, 'searchIssue', newSearch);
        Vue.set(state, 'error', false);
    },

    /**
     * For the error in search.
     *
     * @param {SearchStateInterface} state
     */
    searchError(state: SearchStateInterface): void {
        Vue.set(state, 'error', true);
    },

    /**
     * Update the gameId.
     *
     * @param {SearchStateInterface} state
     * @param {number} newGameId
     */
    updateGameId(state: SearchStateInterface, newGameId: number): void {
        Vue.set(state.searchIssue, 'gameId', newGameId);
    },


    /**
     * Update the search results.
     *
     * @param {SearchStateInterface} state
     * @param {IssueInterface[]} newSearchResults
     */
    updateSearchResults(state: SearchStateInterface, newSearchResults: IssueInterface[]): void {
        Vue.set(state.searchIssue, 'results', newSearchResults);
    },


    /**
     * Update the search CustomerSupport results.
     *
     * @param {SearchStateInterface} state
     * @param {any} newSearchCustomerSupport
     */
    searchCustomerSupport(state: SearchStateInterface, newSearchCustomerSupport: any): void {
        Vue.set(state, 'searchCustomerSupport', newSearchCustomerSupport);
        Vue.set(state, 'error', false);
    },

    /**
     * For the error in search CustomerSupport results.
     *
     * @param {SearchStateInterface} state
     */
    searchCustomerSupportError(state: SearchStateInterface): void {
        Vue.set(state, 'error', true);
    },

    /**
     * Set the total results number.
     *
     * @param {SearchStateInterface} state
     * @param {number} newTotal
     */
    totalResults(state: SearchStateInterface, newTotal: number): void {
        Vue.set(state, 'totalResults', newTotal);
    },



};
